import { CHECKOUT_CONSTANTS, CHECKOUT_PATHS } from './checkout-constants'

export const REQUEST_STATE = {
  STATE_PENDING: 'STATE_PENDING',
  STATE_SUCCESS: 'STATE_SUCCESS',
  STATE_FAILURE: 'STATE_FAILURE',
  STATE_INITIAL: 'STATE_INITIAL',
}

export const PATHS = {
  CHECKOUT: CHECKOUT_PATHS,
}

export const BLOCKINGREASON_DATA_KEYS = {
  BLOCKINGREASON_ARRAY: 'blockingreasonList',
  UPDATE_QUEUED: 'update_queued',
  COUNT: 'count_total',
  LAST_UPDATED: 'lastUpdated',
}

export default {
  REQUEST_STATE,
  CHECKOUT_CONSTANTS,
  // Favorites
  FAVORITES_SORT_AND_FILTER: 'FAVORITES_SORT_AND_FILTER',
  // FAVORITES_FILTER_DATA: 'FAVORITES_FILTER_DATA',
  // Blockingreasons,
  BLOCKINGREASON_DATA_KEYS,
  BLOCKINGREASONS: 'BLOCKINGREASONS',
  BASKET_MESSAGES: 'BASKET_MESSAGES',
}
